/**
 * @module components\ghCustomFilter
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class GhCustomFilter extends Vue {
  @Prop({
    default: () => {
      return [];
    }
  })
  private conditions: IQueryCondtion[];

  private cancel() {
    this.$emit("cancel");
  }

  private submit() {
    this.$emit("submit", this.conditions);
  
  }

  private symbols = ["=", ">", "<", ">=", "<=", "匹配"];
}
